import { type UseMutationResult, useMutation } from '@tanstack/react-query';
import { toast } from 'sonner';

import { type ICreateCoffeeLeadIssueRequest } from '../../../extViewmodels';
import { useUserSession } from '../../../models/hooks/appStateHooks';
import { apiErrorMessage } from './apiErrorMessage';

export function useReportLeadIssue(): UseMutationResult<unknown, Error, ICreateCoffeeLeadIssueRequest> {
	const userSession = useUserSession();

	return useMutation<unknown, Error, ICreateCoffeeLeadIssueRequest>({
		mutationFn: request => userSession.webServiceHelper.callAsync('coffeeleadissue', 'POST', request),
		onSuccess: () => toast.success('Issue reported.'),
		onError: error => toast.error(apiErrorMessage(error, 'Failed to report the issue. Please try again.')),
	});
}
